import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { scaleCoords } from '../utils/canvasFunctions';

class BirdWingRight extends Component {
    constructor(props) {
        super(props);
        this.id = props.id;
        this.basePartName = 'birdWingRight';
        
        this.wingStyle = {
            fill: '#00aaff',
            stroke: 'none',
            opacity: 1,
        };
        
        this.rightWingX = scaleCoords(0.081);
        this.rightWingY = scaleCoords(6.870);
        this.rightWingPath = scaleCoords('c 0.262,-4.655 7.802,-7.704 10.916,-7.736461 4.523,-0.048 9.998,3.615 9.638,8.008 -0.361,4.393 -0.590,-1.475 -1.606,-1.541 -1.016,-0.066 -0.492,0.623 -1.213,0.623 -0.721,0 0.164,-1.115 -0.525,-1.115 -0.721,0.033 0,1.147 -0.787,1.147 -0.787,0 -0.361,-2 -0.951,-2 -0.590,0 -0.164,2 -0.852,2 -0.688,0 -0.131,-2.065 -0.983,-2.032 -0.852,0.033 0.066,2.065 -0.885,2.032 -0.951,-0.033 -0.098,-3.016 -1.705,-3.016 -1.606,0 -0.328,2 -1.08179,2 -0.754,0 -0.197,-0.885 -0.951,-0.951 -0.754,-0.066 -0.197,2 -0.852,1.967 -0.656,-0.033 0,-1.016 -0.951,-1.016 -0.951,0 0.623,1.368 -2.491,1.531 -1.531,0.084 -3.191,0.208 -4.721,0.098');
    }

    render() {       
        const { x, y } = this.props.position;
        
        const { rotDeg } = this.props;
        const { scale } = this.props;
        let transform = '';
        let wingStyle = this.wingStyle;
        // SnyderD - Less than ideal here.. seems rotating AND scaling is very problematic here.  So let's do either/or with scaling 
        // taking the priority - once it's back to full scale it'll start flapping again normally.
        if (scale < 1) {
            transform = `scale(${scale})`;
            wingStyle = {
                ...this.wingStyle,
                opacity: .4,
                transformBox: 'fill-box',
                transformOrigin: '5% 100%',
            };
        } else {
            transform = `rotate(${rotDeg} ${x} ${y})`;
        }
        
        return (
            <path 
                style={wingStyle} 
                d={`m ${x + this.rightWingX},${y + this.rightWingY} ${this.rightWingPath} z`} 
                id={`${this.basePartName}${this.id}`} 
                transform={`${transform}`}
                data-testid={`${this.basePartName}`}
            />
        );
    }
};

BirdWingRight.propTypes = {
    position: PropTypes.shape({
        x:  PropTypes.number.isRequired,
        y:  PropTypes.number.isRequired
    }).isRequired,    
    id: PropTypes.number.isRequired,
    scale: PropTypes.number,
    rotDeg: PropTypes.number,
};

BirdWingRight.defaultProps = {
    scale: 1,
    rotDeg: 0,
};

export default BirdWingRight;